import ordersRepositoryV4 from './orders';

export * from './orders';

const FeatSDKV4 = {
  orders: ordersRepositoryV4,
};

export default FeatSDKV4;
